import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=630a5111&scoped=true&"
import script from "./Login.js?vue&type=script&lang=js&"
export * from "./Login.js?vue&type=script&lang=js&"
import style0 from "./Login.vue?vue&type=style&index=0&id=630a5111&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630a5111",
  null
  
)

export default component.exports